import React from 'react';
import WidgetView from './WidgetView';
import WidgetControllerService from './WidgetControllerService';

/**
 * Moving state out of the controller like this is a bit of an experiment. 
 * Not sure if conceptually this makes issues, but it does make a nicer, cleaner controller,
 */

class WidgetController extends React.Component {
	constructor(props) {
		super(props);
		WidgetControllerService.setModel(this);
	}
	componentDidMount(){
		WidgetControllerService.refresh();
	}
	render(){
		return (
			<WidgetView {...WidgetControllerService.model.state} onChange={(e)=>WidgetControllerService.onChange(e)} onSubmit={(e)=>WidgetControllerService.gotoSkiBro(e)} />
		);
	}
}

export default WidgetController;


// WEBPACK FOOTER //
// ./src/components/widget/WidgetController.js